import React from 'react';
import { cn } from './cn';
import { MonthYearPicker } from './MonthYearPicker';

// Day/month toggle + the matching picker (native date input, or MonthYearPicker).
// value = { mode: 'day' | 'month', date: 'YYYY-MM-DD', period: { month, year } }
export function PeriodPicker({ value, onChange, className }) {
    const { mode, date, period } = value;

    function setMode(m) { onChange({ ...value, mode: m }); }
    function setDate(d) { onChange({ ...value, date: d }); }
    function setPeriod(p) { onChange({ ...value, period: p }); }

    return (
        <div className={cn('flex flex-wrap items-center gap-2', className)}>
            <div className="inline-flex items-center gap-1 rounded-full bg-espresso/[0.05] p-1 ring-1 ring-espresso/10">
                <button type="button" onClick={() => setMode('day')}
                    className={cn(
                        'rounded-full px-3 py-1.5 text-sm font-medium transition-all duration-300 ease-fluid',
                        mode === 'day' ? 'bg-cream-50 text-espresso shadow-ambient' : 'text-espresso-soft hover:text-espresso',
                    )}>
                    Ngày
                </button>
                <button type="button" onClick={() => setMode('month')}
                    className={cn(
                        'rounded-full px-3 py-1.5 text-sm font-medium transition-all duration-300 ease-fluid',
                        mode === 'month' ? 'bg-cream-50 text-espresso shadow-ambient' : 'text-espresso-soft hover:text-espresso',
                    )}>
                    Tháng
                </button>
            </div>
            {mode === 'day' ? (
                <input type="date" value={date} onChange={e => setDate(e.target.value)}
                    className="rounded-2xl bg-cream-200/60 px-4 py-2 text-sm ring-1 ring-espresso/10 focus:bg-cream-50 focus:outline-none focus:ring-2 focus:ring-sage/60" />
            ) : (
                <MonthYearPicker value={period} onChange={setPeriod} />
            )}
        </div>
    );
}
